/**
 * Helpers for reading a detection job payload (`GET /jobs/{projectUuid}/latest`,
 * `GET /jobs/{jobUuid}/timeline`).
 */

/**
 * Resolve which collection a detection job ran for, so its results can be put on
 * the map when the job completes.
 *
 * `job_meta.collection` is the collection the run was started against, carrying
 * the same `{ uuid, name }` shape the progress modal reads its title from — one
 * accessor, one assumed shape. `null` when the payload doesn't carry one, which
 * callers must handle: a job whose collection is unknown can't be selected, only
 * refreshed.
 *
 * @param {object | null | undefined} job
 * @returns {string | null} The collection uuid, or `null` when the payload doesn't carry one.
 */
export const getJobCollectionUuid = job => job?.job_meta?.collection?.uuid ?? null;
